/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import type { TivoPayloadAction } from '../../../../core/tivo/tivo-redux-wrapper';
import { ON_KEY_DOWN_TO_DO_LIST, ON_KEY_UP_TO_DO_LIST } from './todolist.navigation.types';

export const onKeyUpToDoListAction = (
    index: number,
): TivoPayloadAction<{ verticalPosition: number }> => ({
    type: ON_KEY_UP_TO_DO_LIST,
    payload: {
        verticalPosition: index,
    },
});

export const onKeyDownToDoListAction = (
    index: number,
): TivoPayloadAction<{ verticalPosition: number }> => ({
    type: ON_KEY_DOWN_TO_DO_LIST,
    payload: {
        verticalPosition: index,
    },
});
